import * as React from 'react';
import { IconProps } from './types';

export function CircleCrossIcon(props: IconProps) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" {...props}>
			<path d="M10 19C14.95 19 19 14.95 19 10C19 5.05 14.95 1 10 1C5.05 1 1 5.05 1 10C1 14.95 5.05 19 10 19Z" stroke={props.stroke} strokeWidth="1.15" strokeLinecap="round" strokeLinejoin="round"/>
			<path d="M7.45312 12.5471L12.5471 7.45312" stroke={props.stroke} strokeWidth="1.15" strokeLinecap="round" strokeLinejoin="round"/>
			<path d="M12.5471 12.5471L7.45312 7.45312" stroke={props.stroke} strokeWidth="1.15" strokeLinecap="round" strokeLinejoin="round"/>
		</svg>
	);
}
